import { Button } from "../../../../components";
import { ButtonTypes } from "../../../../components/button/Button.types";
import React from 'react';
import { NotificationActionRow, NotificationBox, NotificationIcon, NotificationInfoRow, NotificationMessage, NotificationsBox } from "./NotificationsList.styles";
export var NotificationsList = function NotificationsList(notifications, makeRemoveNotification) {
  return !!notifications.length ? React.createElement(NotificationsBox, {
    className: "notifications__box"
  }, notifications.map(function (notification) {
    return React.createElement(NotificationBox, {
      className: "notification__box",
      fading: notification.fading,
      type: notification.type,
      key: notification.key
    }, React.createElement(NotificationInfoRow, null, React.createElement(NotificationIcon, {
      type: notification.type
    }), React.createElement(NotificationMessage, {
      className: "notification__message"
    }, notification.message)), notification.time === 0 && React.createElement(NotificationActionRow, null, React.createElement(Button, {
      type: ButtonTypes.NAVIGATION,
      className: "notification__ok-button",
      onClick: makeRemoveNotification(notification)
    }, "OK")));
  })) : null;
};